import { useMediaQuery } from '@mantine/hooks';

const DESKTOP_VIEW_WIDTH = 1140;

const useDesktop = () => useMediaQuery(`(min-width: ${DESKTOP_VIEW_WIDTH}px)`);

export default useDesktop;
